/**
 * Created by vlad.p on 8/22/2017.
 */

export class CanadianCurrencyCode {

    public Id: string;
    public Name: string;
    public Code: string;
    public Value: number;

}


// WEBPACK FOOTER //
// ./app/objects/currencyExchange/canadianCurrencyCode.ts